import type { ColumnSettings } from '../../../application/redux/historytable/types';
import { decodeBrowserPersistence } from '../browserPersistenceCodec';
import { browserPersistence2SpaStateMapper } from '../browserPersistenceMapper';
import { decodeHistoryTablePersistence } from '../historyTablePersistenceCodec';
import { historyTablePersistence2TableSettingsMapper } from '../historyTablePersistenceMapper';
import type { PersistedSpaState } from '../types';

const localStorage = window.localStorage;

const STORAGE_PREFIX = 'eventHistory';
export const ROUTE_STATE = 'routeState';

const saveDomainObject = (key: string, value: unknown): void => {
    try {
        localStorage.setItem(`${STORAGE_PREFIX}.${key}`, JSON.stringify(value));
    } catch {
        /* Intentionally left blank */
    }
};

const loadPersistedSpaState = (key: string): PersistedSpaState | undefined => {
    const item = localStorage.getItem(`${STORAGE_PREFIX}.${key}`);
    try {
        if (item) {
            const decoded = decodeBrowserPersistence(JSON.parse(item));
            return browserPersistence2SpaStateMapper(decoded);
        }
    } catch {
        /* Intentionally left blank */
    }

    return;
};

const loadPersistedHistoryTableState = (key: string): ColumnSettings | undefined => {
    const item = localStorage.getItem(`${STORAGE_PREFIX}.${key}`);
    try {
        if (item) {
            const decoded = decodeHistoryTablePersistence(JSON.parse(item));
            return historyTablePersistence2TableSettingsMapper(decoded);
        }
    } catch (e) {
        console.error(e);
    }
    return;
};

const loadDomainObject = <T = unknown>(key: string): T | undefined => {
    try {
        const item = localStorage.getItem(`${STORAGE_PREFIX}.${key}`);
        if (item) {
            return JSON.parse(item) as T;
        }
    } catch {
        /* Intentionally left blank */
    }
    return;
};

const loadString = (key: string): string | null => localStorage.getItem(key);

export const storage = {
    saveDomainObject,
    loadDomainObject,
    loadPersistedSpaState,
    loadPersistedHistoryTableState,
    loadString,
};
